import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import {
  adminDashboardSummary,
  bulkReminderMail,
} from "../../../../appRedux/actions/AdminDashboard";
import { Table, Col, Button, Select, Tooltip } from "antd";
import Widget from "components/Widget/index";
import CustomPagination from "../../../../components/CustomPagination";
import pdtIcon from "assets/images/icons/timeline.svg";
import FPIcon from "assets/images/icons/assignment.svg";
import SRIcon from "assets/images/icons/finance.svg";
import {
  BarChartOutlined,
  BellOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { getQuarter, getRole } from "../../../../helpers";
import { useNavigate } from "react-router-dom";
import LoadingBar from "../../../../components/LoadingBar";
const { Option } = Select;

export const AdminDashboardSummary = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const List = useSelector(
    (state) => state.adminDashboard.admin_dashboard_summary,
  );
  const isLoaded = useSelector(
    (state) => state.adminDashboard.isAdminDashboardSummaryLoaded,
  );

  const [type, setType] = useState("all_three_submitted");
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]); // Store all data for client-side pagination
  const [columns, setColumns] = useState();
  const [showName, setShowName] = useState();
  const [isUserAdmin, setIsUserAdmin] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  useEffect(() => {
    dispatch(adminDashboardSummary(type));
    if (type === "all_three_submitted") {
      setShowName("View Report");
    }
    if (type === "not_submitted") {
      setShowName("Reminder");
    }
    if (type === "saved_but_not_submitted") {
      setShowName("Reminder");
    }
    if (type === "submitted_not_approved") {
      setShowName("View Report");
    }
  }, [type]);

  useEffect(() => {
    setIsUserAdmin(() => {
      return getRole() === "ADMIN";
    });
    if (isLoaded) {
      let columnData,
        rowData = [];
      if (type === "all_three_submitted") {
        let temp_id = 0;
        rowData = List.length
          ? List.map((value) => {
            return {
              key: ++temp_id,
              company_name: value.partner.company_name,
              company_email: value.email,
              [showName]: { partner_id: value.partner.partner_id },
            };
          })
          : [];
        columnData = [
          {
            title: "Company Name",
            dataIndex: "company_name",
            key: "company_name",
            width: 250,
          },
          {
            title: "Company Email",
            dataIndex: "company_email",
            key: "company_email",
          },
          {
            title: showName,
            dataIndex: showName,
            key: showName,
            render: (data) => {
              return (
                <>
                  <div className="gx-flex-row gx-align-items-center font-20">
                    <Tooltip title="PDT">
                      <Button
                        className="PDT_Button"
                        onClick={() => navigateToPdt(data.partner_id)}
                      >
                        <img
                          className="icon icon-timeline color-yellow"
                          src={pdtIcon}
                          alt="PDT"
                          width={16}
                          height={16}
                        />
                        <span>PDT</span>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Filing Plans">
                      <Button
                        className="FP_Button"
                        onClick={() => navigateToFilingPlans(data.partner_id)}
                      >
                        <img
                          className="icon icon-timeline"
                          src={FPIcon}
                          alt="Filing Plans"
                          width={16}
                          height={16}
                        />
                        <span>Filing Plans</span>
                      </Button>
                    </Tooltip>
                    <Tooltip title="Sales Report">
                      <Button
                        className="SR_Button"
                        onClick={() => navigateToSalesReport(data.partner_id)}
                      >
                        <img
                          className="font-20 color-blue"
                          src={SRIcon}
                          alt="Sales Report"
                          width={16}
                          height={16}
                        />
                        <span>Sales Report</span>
                      </Button>
                    </Tooltip>
                  </div>
                </>
              );
            },
          },
        ];
      } else if (type === "submitted_not_approved") {
        let temp_id = 0;
        rowData = List.length
          ? List.map((value) => {
            return {
              key: ++temp_id,
              company_name: value.partner.company_name,
              company_email: value.email,
              [showName]: {
                partner_id: value.partner.partner_id,
                template_data: value.partner.template_data || [], // Fallback to empty array if null/undefined
              },
            };
          })
          : [];
        columnData = [
          {
            title: "Company Name",
            dataIndex: "company_name",
            key: "company_name",
            width: 250,
          },
          {
            title: "Company Email",
            dataIndex: "company_email",
            key: "company_email",
          },
          {
            title: showName,
            dataIndex: showName,
            key: showName,
            render: (data) => {
              let showPDT = false;
              let showFilingPlan = false;
              let showSales = false;
              
              // Ensure data exists and template_data exists and is an array before mapping
              const template_data = data?.template_data || [];
              
              template_data.forEach((obj) => {  // Using forEach instead of map since we're not returning anything
                if (obj !== null) {
                  if (obj.template_type === "pdt" && obj.is_approved !== true) {
                    showPDT = true;
                  }

                  if (obj.template_type === "filing plan" && obj.is_approved !== true) {
                    showFilingPlan = true;
                  }

                  if (obj.template_type === "sales" && obj.is_approved !== true) {
                    showSales = true;
                  }
                }
              });

              return (
                <>
                  <div className="gx-flex-row gx-align-items-center font-20">
                    {showPDT ? (
                      <Tooltip title="PDT">
                        <Button
                          className="PDT_Button"
                          onClick={() => navigateToPdt(data.partner_id)}
                        >
                          <img
                            className="icon icon-timeline color-yellow"
                            src={pdtIcon}
                            alt="PDT"
                            width={16}
                            height={16}
                          />
                          <span>PDT</span>
                        </Button>
                      </Tooltip>
                    ) : null}
                    {showFilingPlan ? (
                      <Tooltip title="Filing Plans">
                        <Button
                          className="FP_Button"
                          onClick={() => navigateToFilingPlans(data.partner_id)}
                        >
                          <img
                            className="icon icon-timeline"
                            src={FPIcon}
                            alt="PDT"
                            width={16}
                            height={16}
                          />
                          <span>Filing Plans</span>
                        </Button>
                      </Tooltip>
                    ) : null}
                    {showSales ? (
                      <Tooltip title="Sales report">
                        <Button
                          className="SR_Button"
                          onClick={() => navigateToSalesReport(data.partner_id)}
                        >
                          <img
                            className="font-20 color-blue"
                            src={SRIcon}
                            alt="PDT"
                            width={16}
                            height={16}
                          />
                          <span>Sales Report</span>
                        </Button>
                      </Tooltip>
                    ) : null}
                  </div>
                </>
              );
            },
          },
        ];
      } else {
        let temp_id = 0;
        rowData = List.length
          ? List.map((value) => {
            return {
              key: ++temp_id,
              company_name: value.partner.company_name,
              company_email: value.email,
            };
          })
          : [];
        columnData = [
          {
            title: "Company Name",
            dataIndex: "company_name",
            key: "company_name",
          },
          {
            title: "Company Email",
            dataIndex: "company_email",
            key: "company_email",
          },
        ];
      }

      // Store all data and set up pagination
      setAllData(rowData);
      setColumns(columnData);

      // Reset pagination when data changes
      setPagination(prev => ({ ...prev, current: 1 }));
    }
  }, [isLoaded]);

  // Effect to handle client-side pagination
  useEffect(() => {
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    const paginatedData = allData.slice(startIndex, endIndex);

    setData(paginatedData);
  }, [allData, pagination]);

  const navigateToPdt = (item) => {
    navigate("/admin/development-timeline/" + item);
  };

  const navigateToFilingPlans = (item) => {
    navigate("/admin/filing-plans/" + item);
  };

  const navigateToSalesReport = (item) => {
    navigate("/admin/sales-report/" + item);
  };

  const handleChange = (value) => {
    setType(value);
  };

  const sendEmail = () => {
    let temp = [];
    if (type === "not_submitted" || type === "saved_but_not_submitted") {
      if (List.length > 0) {
        List.map((value) => {
          let not_submitted = [];
          const template_data = value.partner.template_data;
          if (template_data.length < 1) {
            not_submitted = ["pdt", "filing plan", "sales"];
          } else {
            template_data.map((obj) => {
              if (obj !== null) {
                if (
                  obj.report_status !== "Submitted" &&
                  obj.report_status !== "Approved"
                ) {
                  not_submitted.push(obj.template_type);
                }
              }
            });
          }
          temp.push({
            email_id: value.email,
            not_submitted: not_submitted,
          });
        });
      }
    }
    dispatch(bulkReminderMail({ data: temp }));
  };

  return (
    <Col className="mb-30">
      <Widget
        styleName="gx-order-history dashboard-min-height"
        title={
          <div className="gx-flex-row gx-align-items-center gx-justify-content-between">
            <h2 className="gx-text-capitalize line-height-27 mb-0" style={{ color: "#28398A" }}>
              {getQuarter()
                ? "Admin Dashboard Summary for " + "(" + getQuarter() + ")"
                : "Admin Dashboard Summary"}
            </h2>
            <Select
              className="gx-select-md ml-20"
              defaultValue="all_three_submitted"
              onChange={handleChange}
              style={{ textTransform: "none", marginRight: "10px", marginTop: "4px", width: 240 }}
            >
              <Option value="all_three_submitted">All Data Submitted</Option>
              <Option value="not_submitted">Yet to Submit Data</Option>
              <Option value="saved_but_not_submitted">
                Saved but not Submitted Data
              </Option>
              <Option value="submitted_not_approved">
                Submitted but not Approved
              </Option>
            </Select>
          </div>
        }
        extra={
          <div className="gx-flex-row gx-align-items-center">
            {type === "not_submitted" || type === "saved_but_not_submitted" ? (
              <Button
                type="primary"
                className="mb-0"
                onClick={sendEmail}
                disabled={!isLoaded || !isUserAdmin}
              >
                <BellOutlined /> Send Reminder
              </Button>
            ) : null}
          </div>
        }
      >
        {!isLoaded ? (
          <LoadingBar loading={!isLoaded} />
        ) : (
          <div className="gx-table-responsive">
            <Table
              className="gx-table-no-bordered mpp-list-table admin-dashboard-summary-table"
              columns={columns}
              dataSource={data}
              bordered={false}
              size="small"
              pagination={false}
              scroll={{ y: 'calc(100vh - 400px)' }}
              sticky={{ offsetHeader: 0 }}
            />

            {/* Custom Pagination */}
            <CustomPagination
              current={pagination.current}
              showSizeChanger={true}
              total={allData.length}
              pageSize={pagination.pageSize}
              onChange={(page, pageSize) => {
                setPagination({
                  current: page,
                  pageSize: pageSize,
                });
              }}
            />
          </div>
        )}
      </Widget>
    </Col>
  );
};